import Header from "@/atomic/atoms/Header";
import { PropsView } from "../Models/password";
import Button from "@/atomic/atoms/Button";
import Loading from "@/atomic/atoms/Loading";
import Modal from "@/atomic/atoms/Modal";

export default function RegisterAccessView({
  goBack,
  onChange,
  submit,
  password,
  confirmPassword,
  isDisabled,
  validatesPassword,
  validatesConfirmPassword,
  isVisiblePassword,
  isVisibleConfirmPassword,
  toggleIsVisiblePassword,
  toggleIsVisibleConfirmPassword,
  isLoading,
  error,
  setError,
  success,
  setSuccess,
  goToLogin,
}: PropsView) {
  return (
    <div className="h-full relative flex flex-col bg-white overflow-hidden">
      <Header title="Senha" hasLeftButton goBack={goBack} />
      <main className="flex-1 w-full flex justify-center min-h-0 bg-background">
        <div className="w-full max-w-[480px] px-6 pt-6 pb-8 flex flex-col flex-1 min-h-0">
          <div className="flex-1 min-h-0">
            <h2 className="text-text text-[22px] leading-tight font-primary font-semibold tracking-tight">
              Cadastrar nova senha
            </h2>
            <p className="mt-3 font-primary text-base text-tertiary leading-relaxed">
              Informe seus dados nos campos abaixo
            </p>

            <div className="mt-6 flex flex-col gap-4">
              <div className="relative w-full">
                <input
                  value={password}
                  required
                  onChange={onChange}
                  type={isVisiblePassword ? "text" : "password"}
                  name="password"
                  placeholder="Sua senha"
                  className="w-full h-14 rounded-xl border border-border bg-white px-4 pr-12 text-base font-primary text-text placeholder:text-tertiary focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary"
                />
                <button type="button" onClick={toggleIsVisiblePassword} className="absolute right-4 top-1/2 -translate-y-1/2">
                  <img
                    src={isVisiblePassword ? "/eye-hidden.png" : "/icon-eye.png"}
                    width={24}
                    height={24}
                    alt="Visualizar senha"
                  />
                </button>
              </div>
              <div className="w-full rounded-xl bg-white p-3 flex flex-col gap-1.5">
                {validatesPassword?.map((item, index) => (
                  <div key={index} className="flex items-center gap-2">
                    <img
                      src={item.success ? "/icon-checked.png" : "/icon-unchecked.png"}
                      width={16}
                      height={16}
                      alt=""
                      className="shrink-0"
                    />
                    <p className="text-sm font-primary text-tertiary">{item.text}</p>
                  </div>
                ))}
              </div>

              <div className="relative w-full">
                <input
                  value={confirmPassword}
                  required
                  onChange={onChange}
                  type={isVisibleConfirmPassword ? "text" : "password"}
                  name="confirmPassword"
                  placeholder="Confirmar senha"
                  className="w-full h-14 rounded-xl border border-border bg-white px-4 pr-12 text-base font-primary text-text placeholder:text-tertiary focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary"
                />
                <button type="button" onClick={toggleIsVisibleConfirmPassword} className="absolute right-4 top-1/2 -translate-y-1/2">
                  <img
                    src={isVisibleConfirmPassword ? "/eye-hidden.png" : "/icon-eye.png"}
                    width={24}
                    height={24}
                    alt="Visualizar senha"
                  />
                </button>
              </div>
              <div className="w-full rounded-xl bg-white p-3 flex flex-col gap-1.5">
                {validatesConfirmPassword?.map((item, index) => (
                  <div key={index} className="flex items-center gap-2">
                    <img
                      src={item.success ? "/icon-checked.png" : "/icon-unchecked.png"}
                      width={16}
                      height={16}
                      alt=""
                      className="shrink-0"
                    />
                    <p className="text-sm font-primary text-tertiary">{item.text}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="mt-10 shrink-0">
            <Button
              className="rounded-theme-large bg-primary text-white font-primary font-semibold"
              title="Avançar"
              onClick={submit}
              type="submit"
              isDisabled={isDisabled}
            />
          </div>
        </div>
      </main>
      {error && <Modal
        title="Ops!"
        message="Houve um problema ao trocar sua senha, quer tentar novamente?"
        actionMessage="Tentar novamente"
        action={submit}
        actionSecondMessage="Não!"
        actionSecond={() => setError(false)}
      />}
      {success && <Modal
        title="Muito bem"
        message="Senha alterada com sucesso"
        actionMessage="Fazer login"
        action={() => {
          setSuccess(false);
          goToLogin();
        }}
      />}
      {isLoading && <Loading />}
    </div>
  );
}
